import type { FC } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { usePopover } from 'src/hooks/use-popover';
import { Permissions, useScopeChecker } from 'src/rbac';

import { AccountPopover } from './account-popover';
import { TOP_NAV_TEST_IDS } from '../test-ids';
import { useSelector } from 'react-redux';

export const AccountButton: FC = () => {
  const popover = usePopover<HTMLButtonElement>();
  const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);
  const has = useScopeChecker();
  return (
    <>
      {
        <Box
          component={ButtonBase}
          onClick={popover.handleOpen}
          ref={popover.anchorRef}
          data-testid={TOP_NAV_TEST_IDS.userMenu}
          sx={{
            alignItems: 'center',
            display: 'flex',
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: 'divider',
            height: 40,
            width: 40,
            borderRadius: '50%',
          }}
        >
          <Avatar
            sx={{
              height: 32,
              width: 32,
            }}
          >
            {has(Permissions.PHYSICIAN_DASHBOARD) ? (
              <>{`${user?.firstName?.toUpperCase().charAt(0)}`}</>
            ) : user?.firstName && user?.lastName ? (
              `${user?.lastName?.toUpperCase().charAt(0)}${user?.firstName.toUpperCase().charAt(0)}`
            ) : (
              'T'
            )}
          </Avatar>
        </Box>
      }

      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
